module.exports = __webpack_public_path__ + "static/media/vg.6b4e6688.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/vg.svg
// module id = 284
// module chunks = 0